import { Util } from "../util.js";

const util = new Util();

export class SimilarCombosTile {
	constructor(dom) {
		this._dom = dom;
		this._comboId = util.readFromDataAttribute(dom, "combo_id");
		this._comboSource = util.readFromDataAttribute(dom, "combo_source");
		this._similarityScore = util.readFromDataAttribute(dom, "similarity_score");

		this._initialiseModal();
	}

	_initialiseModal() {
		const adaptiveAlignment = util.isWideViewport() ? "center" : "right";

		this._dom.dataset["ocSheetV1Create.adaptiveAlignment"] = adaptiveAlignment;
	}

	getComboId() {
		return this._comboId;
	}

	getComboSource() {
		return this._comboSource;
	}

	getSimilarityScore() {
		return this._similarityScore;
	}
}
